<template>
    <div class="ui dropdown item">
        {{item.display_name}}
        <i class="dropdown icon"></i>
        <div class="ui vertical menu">
            <div v-for="itm in item.children">
                <menu-dropdown-item v-if="itm.children !== undefined" :item="itm"></menu-dropdown-item>
                <a class="ui item" v-else-if="itm.url !== null" :href="itm.url">
                    {{ itm.display_name }}
                </a>
                <router-link class="ui item" v-else-if="itm.pageId !== null" :to="{name: 'PageView', params: { id: item.pageId, nice_name: encodeURI(item.page.title.toLowerCase().replace(new RegExp(' ', 'g'), '_'))}}">
                    {{itm.display_name}}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'menu-dropdown-item',

  props: ['item'],

  mounted() {
    $(this.$el).dropdown();
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/jquery/MenuDropdownItem.vue